import React, { useState ,useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { useParams } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap'
import './singlebody.css'
// import img1 from '../images/newsimg.webp'
// import img2 from '../images/newsicon1.webp'
// import img3 from '../images/newsicon2.webp'
// import img4 from '../images/newsicon3.webp'
// import img5 from '../images/newsicon4.webp'
// https://sandboxmachine.com/ps/wp-json/blogs/v1/post?id=10

const SingleBody = ({post_status}) => {

    const [post, setPost] = useState([{ID:0}]);
    const [relatedPost, setRelatedPost] = useState([]);
  // const [content, setContent] = useState("");

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  let { id }  = useParams();  
//   let { title }  = useParams();  
  
    useEffect(() => {
        // https://sandboxmachine.com/ps
        
          fetch('https://blog.preferredsquare.com/wp-json/blogs/v1/post?id='+id +'&&post_status='+post_status , { method: "GET"})
          .then(response => response.json())
          .then(data => {
                setPost(data);             
               console.log(data);
            });
  
        //   https://sandboxmachine.com/ps/wp-json/blogs/related-post/post?id=

          fetch('https://blog.preferredsquare.com/wp-json/blogs/related-post/post?id'+id +'&&post_status='+post_status, { method: "GET"})
          .then(response => response.json())
          .then(data => {
            setRelatedPost(data);
              console.log(data);
          });
    
  
        }, [id,post_status]);
  

        function truncateString(string, maxLength) {
            const words = string.split(' ');
            const truncatedWords = words.slice(0, maxLength);
            return truncatedWords.join(' ');
        }
          

    // useEffect(() => {

    //     if(post.ID !== id ) {

    //         fetch('https://sandboxmachine.com/ps/wp-json/blogs/v1/post?id='+id, { method: "GET"})
    //         .then(response => response.json())
    //         .then(data => {
    //         setPost([...post ,data]);

    //         console.log(data);
    //         });

    //         fetch('https://sandboxmachine.com/ps/wp-json/blogs/related-post/post?id='+id, { method: "GET"})
    //         .then(response => response.json())
    //         .then(data => {
    //             setRelatedPost([...relatedPost ,data]);
    //         });
    //     }

    //   }, [post,relatedPost,id]);


    return (
        <>
            <section className='news-section'>
                <Container>
                    <Row>
                        <Col className='col-md-8'>
                            <div className='blog-heading'>
                                <h2 className='news-main-heading'  dangerouslySetInnerHTML={{__html:post.post_title}}></h2>
                            </div>
                            {/* <img className='w-100' src={post.thumbnail} alt='' /> */}
                        </Col>
                        <div className='col-md-8 blog-text paddingright'>
                            <div className='mt-5 blog-content' dangerouslySetInnerHTML={{__html:post.post_content}}>
                            </div>
                            {/* <div className='mt-5'>
                                <p className='news-para'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales.<br /><br />

                                    Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet.<br /><br />

                                    Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus.</p>
                            </div>
                            <div className='mt-5'>
                                <h2 className='news-sub-heading'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h2>
                                <p className='news-para'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet. Pellentesque commodo lacus at sodales sodales.<br /><br />

                                    Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus. Nullam quis imperdiet augue. Vestibulum auctor ornare leo, non suscipit magna interdum eu. Curabitur pellentesque nibh nibh, at maximus ante fermentum sit amet.<br /><br />

                                    Pellentesque commodo lacus at sodales sodales. Quisque sagittis orci ut diam condimentum, vel euismod erat placerat. In iaculis arcu eros, eget tempus orci facilisis id.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris. Maecenas vitae mattis tellus.</p>
                            </div> */}
                        </div>
                        <div className='col-md-4 mt-5 tab-div paddingleft desktop'>
                        
                        <div className='lt-news'>
                        <h3 className='latest-news'>Latest {post.category_name}</h3>
                        
                        {relatedPost.map((relpost) => {
                            // var title =  relpost.post_title.substring(0, 20);
                            const title = truncateString(relpost.post_title, 10);
                            //var content =  relpost.post_content.substring(0, 200);

                            const htmlStr = relpost.post_content;
                            const newStr = htmlStr.replace(/(<([^>]+)>)/ig, '');
                            // const content = newStr.substring(0, 75).replace(/&nbsp;/gi," ").trim()+".."; 
                            const content = truncateString(newStr, 14)+".."; 
                            
                            const url = relpost.post_title.toLowerCase().replace(/(<([^>]+)>)/ig, '').replace("/", "").replace(/ /g, '-');

                            // const content = (newStr.lenght > 75) ?
                            //     newStr.substring(0, 75).replace(/&nbsp;/gi," ")                             
                            // :
                            //     newStr.replace(/&nbsp;/gi," ")+"...";                                
                            
                            return (

                                <Row key={relpost.ID} className='botm-border g-0'>
                                    <Col className='col-md-2 img-div'>
                                        {relpost.thumbnail_image ? 
                                        <img src={relpost.thumbnail_image} alt=''/> : 
                                        <img src={relpost.thumbnail} alt=''/>
                                        }
                                        
                                    </Col>
                                    <Col className='col-md-10 paddingleft2'>
                                        <NavLink onClick={scrollToTop} to={`/single/${relpost.ID}/${url}`} >
                                            <div>
                                            <h4 dangerouslySetInnerHTML={{__html:title}}></h4>
                                            <p className='side-para' dangerouslySetInnerHTML={{__html:content}}></p>
                                            </div>
                                        </NavLink>
                                    </Col>
                                </Row>

                                );
                            })}   

                        </div>  
               
                            {/* <Row className='botm-border'>
                                <Col className='col-md-2 img-div'>
                                    <img src={img2} alt=''/>
                                </Col>
                                <Col className='col-md-10 paddingleft2'>
                                    <h4>Title</h4>
                                    <p className='side-para'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                </Col>
                            </Row>
                            
                            <Row className='botm-border'>
                                <Col className='col-md-2 img-div'>
                                    <img src={img3} alt=''/>
                                </Col>
                                <Col className='col-md-10 paddingleft2'>
                                    <h4>Title</h4>
                                    <p className='side-para'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                </Col>
                            </Row><Row className='botm-border'>
                                <Col className='col-md-2 img-div'>
                                    <img src={img4} alt=''/>
                                </Col>
                                <Col className='col-md-10 paddingleft2'>
                                    <h4>Title</h4>
                                    <p className='side-para'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                </Col>
                            </Row><Row className='botm-border'>
                                <Col className='col-md-2 img-div'>
                                    <img src={img5} alt=''/>
                                </Col>
                                <Col className='col-md-10 paddingleft2'>
                                    <h4>Title</h4>
                                    <p className='side-para'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                </Col>
                            </Row> */}
                        </div>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default SingleBody